import React, { useEffect, useState } from 'react';

import { TextButton } from '@hcs/design-system';
import { Input } from '@hcs/design-system';
import { MenuItem } from '@hcs/design-system';
import { HcCompsIcon } from '@hcs/design-system';
import { usePatchReportPreferencesForOrg } from '@hcs/huell';
import { useReportPreferencesForOrg } from '@hcs/huell';

import { DEFAULT_SELECTED_COMP_LIMIT } from '../../constants';

import styles from './OrgReportPreferences.module.css';

const DEFAULT_SELECTED_COMP_LIMIT_STR = DEFAULT_SELECTED_COMP_LIMIT.toString();
const dataHcName = 'selected-comps-limit-control';
export const SelectedCompsLimitControl = () => {
  const { isFetched, data: orgReportPrefs } = useReportPreferencesForOrg();
  const { mutate: patchOrgPrefs } = usePatchReportPreferencesForOrg();
  const currentPreferenceValue =
    orgReportPrefs?.preferences?.selectedCompsLimit;
  const currentPreferenceStr = currentPreferenceValue
    ? currentPreferenceValue.toString()
    : undefined;
  const [inputValue, setInputValue] = useState<string>(
    currentPreferenceValue
      ? currentPreferenceValue.toString()
      : DEFAULT_SELECTED_COMP_LIMIT_STR
  );
  useEffect(() => {
    if (currentPreferenceStr) {
      setInputValue(currentPreferenceStr);
    }
  }, [currentPreferenceStr]);
  return (
    <MenuItem
      dataHcName={dataHcName}
      Icon={HcCompsIcon}
      label="Selected Comps Limit"
      description="The maximum number of comparable properties that can be selected on a PEXP report. "
      contentRight={
        isFetched &&
        patchOrgPrefs && (
          <div className={styles.Switch}>
            <Input
              dataHcName={`${dataHcName}-input`}
              value={inputValue}
              type="number"
              onChange={(valueStr) => {
                setInputValue(valueStr);
              }}
            />
            <div className={styles.SwitchLabel}>
              <TextButton
                dataHcName={`${dataHcName}-save`}
                label="Save"
                disabled={
                  currentPreferenceStr
                    ? inputValue === currentPreferenceStr
                    : inputValue === DEFAULT_SELECTED_COMP_LIMIT_STR
                }
                onClick={() => {
                  const value = Number(inputValue);
                  if (
                    inputValue &&
                    inputValue !== DEFAULT_SELECTED_COMP_LIMIT_STR &&
                    value
                  ) {
                    patchOrgPrefs([
                      {
                        op: 'add',
                        path: '/selectedCompsLimit',
                        value,
                      },
                    ]);
                  } else {
                    patchOrgPrefs([
                      {
                        op: 'remove',
                        path: '/selectedCompsLimit',
                      },
                    ]);
                  }
                }}
              />
            </div>
          </div>
        )
      }
    />
  );
};
